// extracted by css-extract-rspack-plugin
export default {"description":"BxCLr"};